webpackJsonp([1],{

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_green_bug_card__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_green_bug_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icons_green_bug_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RippleButton__ = __webpack_require__(132);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReportInfestationModal',
  components: {
    RippleButton: __WEBPACK_IMPORTED_MODULE_1__components_RippleButton__["a" /* default */]
  },
  methods: {
    addLocation: function addLocation(place) {
      this.$store.dispatch('addLocation', place);
    },
    addReportPhoto: function addReportPhoto() {
      console.log('addReportPhoto() clicked');
    }
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RippleButton_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc71414e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RippleButton_vue__ = __webpack_require__(316);
function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc71414e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RippleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc71414e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RippleButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ripple-button'
});

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contact-us'
});

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CURRENT_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCATION_BY_ID; });
var CURRENT_LOCATION = 'CURRENT_LOCATION';
var LOCATION_BY_ID = 'LOCATION_BY_ID';

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar__ = __webpack_require__(388);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(391);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar__["a" /* default */]
  }
});

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar'
});

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_svgicon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_svgicon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_svgicon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_App__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.config("https://65eb104a74b645cda49638fc9774704c@sentry.io/1246116").addPlugin(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_svgicon__, {
  classPrefix: 'appicon-'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default.a, {
  dialog: true,
  dynamic: true
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__containers_App__["a" /* default */]);
  }
});

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NotFound__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(164);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// Create the router
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  linkActiveClass: '-active',
  routes: [{
    path: '/',
    name: 'home',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
    },
    meta: { requiresAuth: true }
  }, {
    path: '*',
    name: 'not-found',
    component: __WEBPACK_IMPORTED_MODULE_2__components_NotFound__["a" /* default */]
  }]
});

/**
* Before a route is resolved we check for
* the token if the route is marked as
* requireAuth.
*/
// router.beforeEach(beforeEach)

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f010f21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__(163);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f010f21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('p',[_vm._v("\n    Could not find what you're looking for.\n  ")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7141e029_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(322);
function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7141e029"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7141e029_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041bc5b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(168);
function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041bc5b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 167:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  About\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportInfestationForm_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b011b37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportInfestationForm_vue__ = __webpack_require__(171);
function injectStyle (ssrContext) {
  __webpack_require__(170)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportInfestationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b011b37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportInfestationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 170:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Report Infestation Form\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PestMap_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_553f869e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PestMap_vue__ = __webpack_require__(318);
function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-553f869e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PestMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_553f869e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PestMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(298);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(301);
function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 300:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 303:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(306);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(311);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportInfestationModal_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a32d338_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportInfestationModal_vue__ = __webpack_require__(317);
function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a32d338"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportInfestationModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a32d338_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportInfestationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
var icon = __webpack_require__(88);
icon.register({
  'green_bug_card': {
    width: 548.14,
    height: 549.25,
    viewBox: '0 0 548.14 549.25',
    data: '<defs><linearGradient id="svgicon-green_bug_card-e"><stop offset="0"/><stop offset="1" stop-opacity="0"/></linearGradient><linearGradient id="svgicon-green_bug_card-d"><stop offset="0" stop-color="#22241c"/><stop offset="1" stop-color="#71c837"/></linearGradient><linearGradient id="svgicon-green_bug_card-c"><stop offset="0" stop-color="#cdde87"/><stop offset="1" stop-color="#cdde87" stop-opacity="0"/></linearGradient><linearGradient id="svgicon-green_bug_card-b"><stop offset="0" stop-color="#8dd35f"/><stop offset="1" stop-color="#8dd35f" stop-opacity="0"/></linearGradient><linearGradient id="svgicon-green_bug_card-a"><stop offset="0" stop-color="#b3ff80"/><stop offset="1" stop-color="#b3ff80" stop-opacity="0"/></linearGradient><radialGradient r="22.322" fy="202.419" fx="233.927" cy="202.419" cx="233.927" gradientTransform="matrix(-.04785 .59814 -1.02066 -.08165 451.722 78.713)" gradientUnits="userSpaceOnUse" id="svgicon-green_bug_card-f" xlink:href="#svgicon-green_bug_card-c"/><radialGradient r="22.322" fy="202.419" fx="233.927" cy="202.419" cx="233.927" gradientTransform="matrix(-.04785 .59814 -1.02066 -.08165 451.722 78.713)" gradientUnits="userSpaceOnUse" id="svgicon-green_bug_card-g" xlink:href="#svgicon-green_bug_card-c"/><radialGradient r="82.222" fy="373.711" fx="84.431" cy="373.711" cx="84.431" gradientTransform="matrix(-.1262 .80237 -1.11014 -.17461 414.459 258.617)" gradientUnits="userSpaceOnUse" id="svgicon-green_bug_card-h" xlink:href="#svgicon-green_bug_card-b"/><radialGradient r="144.548" fy="549.179" fx="628.506" cy="549.179" cx="628.506" gradientTransform="matrix(-.86052 -.06557 .09711 -1.27435 1116.016 1293.453)" gradientUnits="userSpaceOnUse" id="svgicon-green_bug_card-i" xlink:href="#svgicon-green_bug_card-a"/><radialGradient r="144.548" fy="588.538" fx="641.084" cy="588.538" cx="641.084" gradientTransform="matrix(-.34475 -.04404 .1039 -.81342 788.12 1026.781)" gradientUnits="userSpaceOnUse" id="svgicon-green_bug_card-j" xlink:href="#svgicon-green_bug_card-a"/><radialGradient xlink:href="#svgicon-green_bug_card-c" id="svgicon-green_bug_card-k" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-.04785 .59814 -1.02066 -.08165 451.722 78.713)" cx="233.927" cy="202.419" fx="233.927" fy="202.419" r="22.322"/><radialGradient xlink:href="#svgicon-green_bug_card-c" id="svgicon-green_bug_card-l" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-.04785 .59814 -1.02066 -.08165 451.722 78.713)" cx="233.927" cy="202.419" fx="233.927" fy="202.419" r="22.322"/><radialGradient xlink:href="#svgicon-green_bug_card-b" id="svgicon-green_bug_card-m" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-.1262 .80237 -1.11014 -.17461 414.459 258.617)" cx="84.431" cy="373.711" fx="84.431" fy="373.711" r="82.222"/><radialGradient xlink:href="#svgicon-green_bug_card-a" id="svgicon-green_bug_card-n" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-.86052 -.06557 .09711 -1.27435 1116.016 1293.453)" cx="628.506" cy="549.179" fx="628.506" fy="549.179" r="144.548"/><radialGradient xlink:href="#svgicon-green_bug_card-a" id="svgicon-green_bug_card-o" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-.34475 -.04404 .1039 -.81342 788.12 1026.781)" cx="641.084" cy="588.538" fx="641.084" fy="588.538" r="144.548"/></defs><path pid="0" _fill="none" d="M5.202 6h535.14v538.247H5.201z"/><path pid="1" d="M369.138 37.254c26.572 21.474 13.886 54.212 13.886 82.249" _fill="none" _stroke="#307d39" stroke-width="12.6"/><path pid="2" d="M381.956 28.856a16.022 16.556 0 0 1-16.023 16.557 16.022 16.556 0 0 1-16.022-16.557A16.022 16.556 0 0 1 365.933 12.3a16.022 16.556 0 0 1 16.023 16.556z" _fill="#337f00" fill-rule="evenodd" _stroke="#307d39" stroke-width="12.6" stroke-linecap="round"/><path pid="3" transform="rotate(-33.135 -17.09 -98.444)" d="M248.881 215.459a16.022 16.556 0 0 1-16.022 16.556 16.022 16.556 0 0 1-16.022-16.556 16.022 16.556 0 0 1 16.022-16.557 16.022 16.556 0 0 1 16.022 16.557z" _fill="url(#svgicon-green_bug_card-k)" fill-rule="evenodd"/><path pid="4" d="M236.063 223.856c26.573 21.474 13.886 54.212 13.886 82.249" _fill="none" _stroke="#307d39" stroke-width="12.6" transform="matrix(-.41199 -.88082 -.90581 .42368 808.841 237.398)"/><path pid="5" d="M248.881 215.459a16.022 16.556 0 0 1-16.022 16.556 16.022 16.556 0 0 1-16.022-16.556 16.022 16.556 0 0 1 16.022-16.557 16.022 16.556 0 0 1 16.022 16.557z" _fill="#337f00" fill-rule="evenodd" _stroke="#307d39" stroke-width="12.6" stroke-linecap="round" transform="matrix(-.41199 -.88082 -.90581 .42368 808.841 237.398)"/><path pid="6" d="M248.881 215.459a16.022 16.556 0 0 1-16.022 16.556 16.022 16.556 0 0 1-16.022-16.556 16.022 16.556 0 0 1 16.022-16.557 16.022 16.556 0 0 1 16.022 16.557z" transform="matrix(.15014 -.96917 -.98371 -.12669 696.577 377.982)" _fill="url(#svgicon-green_bug_card-l)" fill-rule="evenodd"/><g fill-rule="evenodd"><path pid="7" d="M450.117 202.52a81.631 49.473 34.747 0 1-95.272-5.875 81.631 49.473 34.747 0 1-38.877-87.177 81.631 49.473 34.747 0 1 95.272 5.875 81.631 49.473 34.747 0 1 38.877 87.178z" _fill="#3c9500"/><path pid="8" d="M63.784 303.894a82.222 49.831 0 0 1-82.222 49.831 82.222 49.831 0 0 1-82.221-49.831 82.222 49.831 0 0 1 82.221-49.831 82.222 49.831 0 0 1 82.222 49.831z" transform="rotate(34.747 366.796 853.937) scale(.89764)" _fill="url(#svgicon-green_bug_card-m)"/></g><g _fill="#36623f" fill-rule="evenodd" _stroke="#36623f" stroke-width="38.6" stroke-linecap="round"><path pid="9" d="M-185.963-3.025c12.31 31.004 9.897 142.324 7.743 161.627M-336.763 72.75c28.249 17.742 92.065 108.986 101.73 125.833M-281.322 281.107c-26.355-.139-108.407-62.123-128.311-98.586" transform="matrix(-.1591 -1.10326 -1.05816 .0356 464.114 64.912)"/></g><path pid="10" d="M248.173 72.157c12.311 31.003 9.897 142.323 7.743 161.626M97.373 147.931c28.249 17.742 92.065 108.986 101.73 125.834M152.814 356.288c-26.355-.139-108.407-62.122-128.311-98.586" _fill="none" _stroke="#36623f" stroke-width="38.6" stroke-linecap="round"/><g><path pid="11" d="M389.116 406.779a163.839 190.154 42.933 0 1-249.009 48.004 163.839 190.154 42.933 0 1-11.712-247.143 163.839 190.154 42.933 0 1 248.931-49.637 163.839 190.154 42.933 0 1 13.358 246.814" _fill="#379d32" fill-rule="evenodd"/><path pid="12" transform="matrix(-.71443 -.44775 .62549 -.8754 323.573 1027.302)" d="M658.702 537.629a148.905 184.74 0 0 1-148.904 184.74 148.905 184.74 0 0 1-148.905-184.74 148.905 184.74 0 0 1 148.905-184.74 148.905 184.74 0 0 1 148.904 184.74z" _fill="url(#svgicon-green_bug_card-n)" fill-rule="evenodd"/><path pid="13" d="M133.907 442.307c-6.649-121.103 93.557-295.78 233.474-284.547" _fill="none" _stroke="#2b672e" stroke-width="17.177" stroke-linecap="round"/><path pid="14" transform="matrix(-.46262 -.53245 .72954 -.66095 69.916 889.342)" d="M654.346 537.629a144.548 184.74 0 0 1-144.548 184.74 144.548 184.74 0 0 1-144.549-184.74 144.548 184.74 0 0 1 144.549-184.74 144.548 184.74 0 0 1 144.548 184.74z" _fill="url(#svgicon-green_bug_card-o)" fill-rule="evenodd"/></g>'
  }
});

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect"},[_vm._t("default",[_vm._v("RippleButton")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"report-infestation","transition":"pop-out","width":"50%","height":"60%"}},[_c('form',{attrs:{"action":"#"}},[_c('div',{staticClass:"report-card-square mdl-card mdl-shadow--2dp"},[_c('div',{staticClass:"mdl-card__title mdl-card--expand"},[_c('h2',{staticClass:"mdl-card__title-text"},[_vm._v("REPORT INFESTATION")])]),_vm._v(" "),_c('div',{staticClass:"mdl-card__supporting-text"},[_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--3-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('label',{staticClass:"mdl-textfield__label",attrs:{"for":"label"}},[_vm._v("Add an optional label:")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--7-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{staticClass:"mdl-textfield__input",attrs:{"placeholder":"My garden shed ...","type":"text","id":"label"}})]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('label',{staticClass:"mdl-textfield__label",attrs:{"for":"address"}},[_vm._v("Address:")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--7-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('gmap-autocomplete',{staticClass:"mdl-textfield__input",attrs:{"placeholder":"type here"},on:{"place_changed":_vm.addLocation}})],1),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col"},[_c('label',{staticClass:"mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",attrs:{"for":"checkbox-1"}},[_c('span',{staticClass:"mdl-checkbox__label"},[_vm._v("Infestation resolved")])])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--1-col"},[_c('input',{staticClass:"mdl-checkbox__input",attrs:{"type":"checkbox","id":"checkbox-1"}})])])])]),_vm._v(" "),_c('div',{staticClass:"mdl-card__actions mdl-card--border"},[_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--4-coll"},[_c('ripple-button',{staticClass:"report-card-button",nativeOn:{"click":function($event){_vm.addReportPhoto()}}},[_vm._v("\n            Add photo\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--4-coll"},[_c('ripple-button',{staticClass:"report-card-button",nativeOn:{"click":function($event){_vm.cancelReportModal()}}},[_vm._v("\n            Cancel\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--4-coll"},[_c('ripple-button',{staticClass:"report-card-button",nativeOn:{"click":function($event){_vm.SubmitReportForm()}}},[_vm._v("\n            Submit\n          ")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pest-map-view"}},[_c('report-infestation-modal'),_vm._v(" "),_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--6-col"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('ripple-button',{nativeOn:{"click":function($event){_vm.showReportModal()}}},[_vm._v("\n        Report an infestation\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--6-col"},[_c('ripple-button',{nativeOn:{"click":function($event){_vm.centerOnLocation()}}},[_vm._v("\n        Center on current location\n      ")])],1)]),_vm._v(" "),(_vm.center)?_c('div',[_c('div',{staticClass:"pest-map",attrs:{"id":"pest-map"}},[_c('gmap-map',{ref:"pestsMap",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.center,"zoom":16,"map-type-id":"hybrid"}},_vm._l((_vm.reportedLocations),function(location,index){return _c('gmap-marker',{key:index,attrs:{"position":location,"clickable":true},on:{"click":function($event){_vm.selectReportedLocation(index)}}})}))],1)]):_c('div',{staticClass:"pest-map",attrs:{"id":"pest-map"}},[_c('gmap-map',{ref:"pestsMap",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.bugtown,"zoom":15,"map-type-id":"hybrid"}},_vm._l((_vm.reportedLocations),function(location,index){return _c('gmap-marker',{key:index,attrs:{"position":location,"clickable":true},on:{"click":function($event){_vm.selectReportedLocation(index)}}})}))],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdl-button mdl-js-button mdl-button--icon",attrs:{"id":"demo-menu-lower-left"}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mdl-menu mdl-menu--bottom-left mdl-js-menu mdl-js-ripple-effect",attrs:{"for":"demo-menu-lower-left"}},[_c('li',{staticClass:"mdl-menu__item"},[_vm._v("Report an infestation")]),_vm._v(" "),_c('li',{staticClass:"mdl-menu__item mdl-menu__item--full-bleed-divider"},[_vm._v("Center map")]),_vm._v(" "),_c('li',{staticClass:"mdl-menu__item",attrs:{"disabled":""}},[_vm._v("Disabled Action")]),_vm._v(" "),_c('li',{staticClass:"mdl-menu__item"},[_vm._v("Yet Another Action")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUs_vue__ = __webpack_require__(134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c31b14e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__ = __webpack_require__(321);
function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c31b14e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Contact Us\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('about'),_vm._v(" "),_c('report-infestation-form'),_vm._v(" "),_c('pest-map',{attrs:{"name":"ants"}}),_vm._v(" "),_c('contact-us')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locations__ = __webpack_require__(328);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
    paths: ['locations'],
    storage: {
      getItem: function getItem(key) {
        return __WEBPACK_IMPORTED_MODULE_3_js_cookie__["get"](key);
      },
      // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
      setItem: function setItem(key, value) {
        return __WEBPACK_IMPORTED_MODULE_3_js_cookie__["set"](key, value, { expires: 3, secure: true });
      },
      removeItem: function removeItem(key) {
        return __WEBPACK_IMPORTED_MODULE_3_js_cookie__["remove"](key);
      }
    }
  })],
  modules: {
    locations: __WEBPACK_IMPORTED_MODULE_4__locations__["a" /* default */]
  },
  strict: true
}));

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(363);





/* harmony default export */ __webpack_exports__["a"] = ({ state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */], getters: __WEBPACK_IMPORTED_MODULE_2__getters__, mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */], actions: __WEBPACK_IMPORTED_MODULE_3__actions__ });

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  currentLocation: null,
  reportedLocations: null
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_types__ = __webpack_require__(140);





var _TYPES$CURRENT_LOCATI;



/* harmony default export */ __webpack_exports__["a"] = (_TYPES$CURRENT_LOCATI = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_TYPES$CURRENT_LOCATI, __WEBPACK_IMPORTED_MODULE_4__store_types__["a" /* CURRENT_LOCATION */], function (state, obj) {
  state.currentLocation = obj;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_TYPES$CURRENT_LOCATI, __WEBPACK_IMPORTED_MODULE_4__store_types__["b" /* LOCATION_BY_ID */], function (state, newLocation) {
  if (state.reportedLocations === null) {
    console.log('initialize reportedLocations');
    state.reportedLocations = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, newLocation.place_id, newLocation);
  } else if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(state.reportedLocations) === 'object') {
    console.log('looking up place_id:', newLocation.place_id);
    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.reportedLocations).includes(newLocation.place_id)) {
      console.log('location already known', newLocation.place_id);
    } else {
      console.log('adding new location', newLocation.place_id);
      var updatedLocations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, newLocation.place_id, newLocation), state.reportedLocations);
      console.log('updatedLocations:', updatedLocations);
      state.reportedLocations = updatedLocations;
    }
  }
}), _TYPES$CURRENT_LOCATI);

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentLocation", function() { return currentLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportedLocations", function() { return reportedLocations; });
var currentLocation = function currentLocation(state) {
  return state.currentLocation;
};

var reportedLocations = function reportedLocations(state) {
  return state.reportedLocations;
};

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentLocation", function() { return setCurrentLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocation", function() { return addLocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_types__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_reported_location__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





// this is the current location
var setCurrentLocation = function setCurrentLocation(_ref, geolocation) {
  var commit = _ref.commit,
      state = _ref.state;

  var lat = geolocation.coords.latitude;
  var lng = geolocation.coords.longitude;
  console.log('reported geoLocation: ', geolocation);
  // let lookupUrl = `https://maps.googleapis.com/maps/api/geocode/json?key=${process.env.GOOGLE_MAPS_API_KEY}&latlng=${lat},${lng}`
  // console.log('processing', lookupUrl)
  // Optionally the request above could also be done as
  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/maps/api/geocode/json', {
    baseURL: 'https://maps.googleapis.com',
    params: {
      key: "AIzaSyCzZlnxI_8JxAVgPsS6TZ6jub6DASGPd0U",
      latlng: lat + ',' + lng
    }
  }).then(function (response) {
    console.log('Google GeoCode Response Status', response.status);
    console.log('Google GeoCode Locations: ', response.data.results);
    var currentLocation = new __WEBPACK_IMPORTED_MODULE_1__models_reported_location__["a" /* ReportedLocation */](response.data.results[0]);
    console.log('committing currentLocation: ', currentLocation);
    commit(__WEBPACK_IMPORTED_MODULE_0__store_types__["a" /* CURRENT_LOCATION */], currentLocation);
    commit(__WEBPACK_IMPORTED_MODULE_0__store_types__["b" /* LOCATION_BY_ID */], currentLocation);
  }).catch(function (error) {
    console.log('error using google geocode api', error);
  });
};

var addLocation = function addLocation(_ref2, place) {
  var commit = _ref2.commit,
      state = _ref2.state;

  console.log('new location input: ', place);
  var newLocation = new __WEBPACK_IMPORTED_MODULE_1__models_reported_location__["a" /* ReportedLocation */](place);
  commit(__WEBPACK_IMPORTED_MODULE_0__store_types__["b" /* LOCATION_BY_ID */], newLocation);
};

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportedLocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var ReportedLocation = function () {
  function ReportedLocation(place) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ReportedLocation);

    console.log('build location from:', place);

    if (place.place_id === undefined) {
      throw new Error('location input is missing attribute: place_id');
    }

    var _arr = ['place_id', 'url', 'name', 'formatted_address'];
    for (var _i = 0; _i < _arr.length; _i++) {
      var attribute = _arr[_i];
      if (place[attribute] !== undefined) {
        this[attribute] = place[attribute];
      }
    }

    if (typeof place.geometry.location.lat === 'function') {
      this.lat = place.geometry.location.lat();
      this.lng = place.geometry.location.lng();
    } else {
      this.lat = place.geometry.location.lat;
      this.lng = place.geometry.location.lng;
    }

    var _arr2 = ['lat', 'lng'];
    for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
      var _attribute = _arr2[_i2];
      if (this[_attribute] === undefined) {
        throw new Error('input has invalid attribute: ' + _attribute);
      }
    }
    console.log('constructed ReportedLocation:', this);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ReportedLocation, [{
    key: 'position',
    value: function position() {
      return {
        lat: this.lat,
        lng: this.lng
      };
    }
  }, {
    key: 'marker',
    value: function marker() {
      return {
        name: this.name,
        url: this.url,
        lat: this.lat,
        lng: this.lng
      };
    }
  }]);

  return ReportedLocation;
}();

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_030f64bf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(392);
function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-030f64bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_030f64bf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 387:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33372836_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(390);
function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33372836_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 389:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-layout__header-row"},[_c('nav',{staticClass:"mdl-navigation fixed-navbar"},[_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"/"}},[_vm._v("Home map")]),_vm._v(" "),_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#map"}},[_vm._v("View map")]),_vm._v(" "),_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#blog"}},[_vm._v("Blog")]),_vm._v(" "),_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"}},[_vm._v("About")]),_vm._v(" "),_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"}},[_vm._v("Contact")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"mdl-layout__header mdl-layout__header--waterfall"},[_vm._m(0),_vm._v(" "),_c('navbar')],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-layout__header-row"},[_c('div',{staticClass:"mdl-layout__title"},[_vm._v("PestHelp")]),_vm._v(" "),_c('div',{staticClass:"mdl-layout-spacer"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'not-found'
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_About__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ReportInfestationForm__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PestMap__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContactUs__ = __webpack_require__(319);
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    About: __WEBPACK_IMPORTED_MODULE_0__components_About__["a" /* default */],
    ReportInfestationForm: __WEBPACK_IMPORTED_MODULE_1__components_ReportInfestationForm__["a" /* default */],
    PestMap: __WEBPACK_IMPORTED_MODULE_2__components_PestMap__["a" /* default */],
    ContactUs: __WEBPACK_IMPORTED_MODULE_3__components_ContactUs__["a" /* default */]
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about'
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report-infestation-form'
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ReportInfestationModal__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RippleButton__ = __webpack_require__(132);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
  load: {
    key: "AIzaSyCzZlnxI_8JxAVgPsS6TZ6jub6DASGPd0U",
    libraries: ['places']
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pest-map',

  data: function data() {
    return {
      bugtown: { lat: 38.150556, lng: -87.840278 },
      centered: false
    };
  },


  components: {
    ReportInfestationModal: __WEBPACK_IMPORTED_MODULE_4__components_ReportInfestationModal__["a" /* default */],
    RippleButton: __WEBPACK_IMPORTED_MODULE_5__components_RippleButton__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    center: function center(state) {
      return state.locations.currentLocation;
    },
    reportedLocations: function reportedLocations(state) {
      return state.locations.reportedLocations;
    }
  })),

  methods: {
    centerOnLocation: function centerOnLocation() {
      var _this = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          _this.$refs.pestsMap.$mapCreated.then(function () {
            console.log('map ready to center on location');
            _this.$store.dispatch('setCurrentLocation', position);
            _this.$refs.pestsMap.resizePreserveCenter();
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$gmapDefaultResizeBus.$emit('resize');
          });
        });
      }
    },
    showReportModal: function showReportModal() {
      console.log('clicked showReportModal');
      this.$modal.show('report-infestation');
    },
    selectReportedLocation: function selectReportedLocation(index) {
      console.log('clicked selectReportedLocation with index', index);
    }
  },

  mounted: function mounted() {
    this.centerOnLocation();
  },

  watch: {
    reportedLocations: function reportedLocations() {
      this.$refs.pestsMap.$mapCreated.then(function () {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$gmapDefaultResizeBus.$emit('resize');
      });
    }
  }
});

/***/ })

},[148]);


// WEBPACK FOOTER //
// static/js/app.a03289b4eafea80df6e2.js